import { Config } from './config.const';
import { ISubject } from './model/soggetto';


export function search<T>(key: string, soggetti: T[], selector: (item: T) => ISubject): T[] {
    if (key !== "") {
        let list = searchOPT(key, soggetti, selector);
        // let list = searchAlgorithmEVOLUS(key, soggetti);

        return list
            .sort((a, b) =>
                (a.cognome > b.cognome) ? 1 : (a.cognome === b.cognome) ? ((a.nome > b.nome) ? 1 : -1) : -1)
            .slice(0, Config.searchMaxResultNumber);

    } else {
        return soggetti.slice(0, Config.searchMaxResultNumber);
    }
}

function searchOPT<T>(key: string, soggetti: T[], selector: (item: T) => ISubject) {
    let list = [];
    let word = key.trim().toLowerCase().split(' ').filter(w => w.length > 0);
    switch (word.length) {
        case 1:
            list = soggetti
                .filter(s => isMatch(selector(s).cognome, key));
        case 2:
            list = soggetti
                .filter(s => {
                    const subject = selector(s);
                    return isMatch(subject.cognome, key) ||
                        (isMatch(subject.cognome, word[0]) && isMatch(subject.nome, word[1]));
                });
        case 3:
        default:
            list = soggetti
                .filter(s => {
                    const subject = selector(s);
                    return isMatch(subject.cognome, key) ||
                        (isMatch(subject.cognome, word[0]) && isMatch(subject.nome, word[1])) ||
                        (isMatch(subject.cognome, word[0] + " " + word[1]) && isMatch(subject.nome, word[2]));
                });
    }

    return list;
}

function isMatch(soggetto: string, key: string) {
    return soggetto != null && soggetto.trim().toLowerCase().startsWith((key || '').toLowerCase());
}

// function searchAlgorithmEVOLUS(key: string, soggetti: any[]) {
//     let list = [];
//     let cog = "";
//     let nome1 = "";
//     let cog1 = "";
//     let cog2 = "";
//     let nome2 = "";

//     cog = key.toUpperCase();
//     let posblank = key.indexOf(" ", 0);
//     if (posblank > 0) {
//         cog1 = key.substring(0, posblank);
//         nome1 = key.substring(posblank + 1);
//         let posblank2 = nome1.indexOf(" ", 0);
//         if (posblank2 > 0) {
//             cog2 = cog1 + " " + nome1.substring(0, posblank2);
//             nome2 = nome1.substring(posblank2 + 1);
//         }
//     }

//     if (nome1 == "" || nome1 == " ") {
//         list = soggetti
//             .filter((s: ISubject) =>
//                 s.cognome != null && s.cognome.trim().toUpperCase().startsWith(cog)
//             );
//     }
//     else {
//         if (nome2 == "" || nome2 == " ") {
//             list = soggetti
//                 .filter((s: ISubject) =>
//                     s.cognome != null && s.cognome.trim().toUpperCase().startsWith(cog) ||
//                     s.cognome != null && s.nome != null && s.cognome.trim().toUpperCase().startsWith(cog1) && s.nome.trim().toUpperCase().startsWith(nome1) // cognome inizia con "di" e il nome con "le"
//                 );
//         }
//         else {
//             list = soggetti
//                 .filter((s: ISubject) =>
//                     s.cognome != null && s.cognome.trim().toUpperCase().startsWith(cog) ||
//                     s.cognome != null && s.nome != null && s.cognome.trim().toUpperCase().startsWith(cog1) && s.nome.trim().toUpperCase().startsWith(nome1) ||
//                     s.cognome.trim().toUpperCase().startsWith(cog2) && s.nome.trim().toUpperCase().startsWith(nome2)
//                 );
//         }
//     }
//     return list;
// }



// WEBPACK FOOTER //
// ./src/app/ricerca.soggetti.ts